import HumanizerAddressInner from './HumanizerAddressInner'

export default HumanizerAddressInner
